<template>
<v-container fluid class="fill-height pa-0">
  <v-overlay :value="!isLoaded" z-index="0">
     <v-progress-circular indeterminate size="64"></v-progress-circular>
   </v-overlay>

 <MetroMap v-if="!error" :map='map'/>
 <v-container v-if="error">Oops, something went wrong creating your metro map. Please contact an administrator!</v-container>
 </v-container>
</template>

<script>

import MetroMap from '../components/MetroMap.vue'

export default {
  name: 'Map',
  components: {
    MetroMap
  },
  data () {
    return {
      map: {},
      error: false,
      errorMessage: '',
      isLoaded: false,
      timer: ''
    }
  },
  created () {
    this.loadMap()
    // this.timer = setTimeout(this.loadMap, 3000)
  },
  methods: {

    loadMap: function () {
      // console.log('this.map')
      this.axios.get('maps/' + this.$route.params.mapId)
        .then(response => {
          this.map = response.data
          // console.log(this.map)
          this.isLoaded = true

          if (this.map.output.Error) {
            this.error = true
            this.errorMessage = this.map.output.Error
          } else {
            this.error = false
          }

          clearInterval(this.timer)
        },
        (error) => {
          if (error.response.status === 423) {
            this.timer = setTimeout(this.loadMap, 3000)
          }
        })
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
